import { createFileRoute } from "@tanstack/react-router";
import { NotesGrid } from "../components/NotesGrid";

export const Route = createFileRoute("/trash")({
  component: () => <NotesGrid title="Trash" filter={{ trashed: true }} trashView />,
});
